import React from 'react';
import SignIn from './section-components/sign-in';

const SignInPage = () => {
    return <div>
        <SignIn />
    </div>
}

export default SignInPage

